import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'replaceLineBreaks'})
export class NToBR implements PipeTransform {

  transform(value: string): string {
      return value.replace(/\n/g, '<br/>');
   }
}



// WEBPACK FOOTER //
// ./src/pipes/nToBR.pipe.ts